module.exports = __webpack_public_path__ + "static/affiliate/affiliate-square_ski-bro2--swiss@2-40ac77afe4459323f82f4064765fd91f.jpg";